import React from "react";
import Select from "react-select";
import { useQuery } from "@tanstack/react-query";
import { fetchPaymentType } from "services/dropdown";
import { DROPDOWN_STALE_TIME } from "utils/constants";
import { Controller } from "react-hook-form";

const PaymentTypeDropdown = ({
  errors,
  control,
  setValue,
  getValues,
  watch,
  required
}) => {
  const paymentTypeName = getValues().payment_mode;
  const selectedPaymentType = watch("payment_type");

  const {
    data: PaymentType,
    isLoading,
    error,
  } = useQuery(["PaymentType"], () => fetchPaymentType(), {
    keepPreviousData: false,
    staleTime: DROPDOWN_STALE_TIME,
  });

  if (isLoading) return <div>Loading...</div>;
  if (error) return <div>Error loading Payment Modes</div>;

  const modifiedData = PaymentType?.data?.data?.map((ele) => ({
    ...ele,
    payment_type_id: ele.id,
  }));

  const options =
    modifiedData?.map((paymentMode) => ({
      value: paymentMode.payment_type_id,
      label: paymentMode.payment_type,
    })) || [];

  const selectedOption = options.find(
    (option) => option.value === selectedPaymentType || paymentTypeName
  );
  return (
    <Controller
      name="payment_type"
      control={control}
      rules={{
        required: required ? "Payment Type is required" : false,
        validate: (value) => {
          if (required && !value) return "Payment Type is required";
          return true;
        },
      }}
      render={({ field }) => (
        <Select
          {...field}
          options={options}
          isClearable
          value={selectedOption || null}
          placeholder="Select Payment Type"
          menuPortalTarget={document.body}
          styles={{
            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
          }}
          onChange={(selectedOption) => {
            const value = selectedOption ? selectedOption.value : "";
            field.onChange(value);
            setValue("payment_type", value);
          }}
          className={`react-select-container ${errors.payment_mode_id ? "is-invalid" : ""
            }`}
        />
      )}
    />
  );
};

export default PaymentTypeDropdown;
